<div [ngClass]="cls" *ngIf="time">
    {{ time | date: format }}
</div>
